export const getItem = (key: string) => {
  if (typeof window === "undefined") return null;
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
};

export const setItem = (key: string, value: string) => {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.setItem(key, value);
  } catch {
    // ignore write failures (private mode, quota exceeded)
  }
};

export const removeItem = (key: string) => {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem(key);
};
